import { BadgeActivityFilterParameters,
        BadgeActivityPaginatedResponse,
        BadgeActivityPaginationParameters,
        BadgeActivityRequestType,
        ResponseBadgeActivityDetails,
    } from "@/store/badge-activity/types";
import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { AxiosInstance } from "axios";
import { PaginatedSearchQueryParams } from "@/store/types";

class BadgeActivityApi {
    private axios: AxiosInstance;
    private axiosJson: AxiosInstance;

    constructor() {
        this.axios = axiosInstance;
        this.axiosJson = axiosJsonInstance;
    }

    public async badgeActivitySupported(responseId: number): Promise<ResponseBadgeActivityDetails> {
        const { data } = await this.axios.get(`/Responses/BadgeActivity/${responseId}`);
        return data
    }

    public async getPaginatedBadgeActivity(
            responseBadgeActivityDetails: ResponseBadgeActivityDetails,
            badgeActivityFilterParameters: BadgeActivityFilterParameters,
            paginatedSearchQueryParams: PaginatedSearchQueryParams
    ): Promise<BadgeActivityPaginatedResponse> {
        try {
            const formattedStartDate = new Date(badgeActivityFilterParameters.startDate)
            formattedStartDate.setHours(0, 0, 0, 0);

            const formattedEndDate = new Date(badgeActivityFilterParameters.endDate)
            formattedEndDate.setHours(23, 59, 59, 999);

            const badgeActivityRequest: BadgeActivityPaginationParameters = {
                requestType: BadgeActivityRequestType.DeviceService,
                pageNumber: paginatedSearchQueryParams.page,
                pageSize: paginatedSearchQueryParams.pageSize,
                filter: {
                    searchTerm: badgeActivityFilterParameters.searchTerm,
                    sourceId: responseBadgeActivityDetails.extraValue,
                    startDate: formattedStartDate.toISOString(),
                    endDate: formattedEndDate.toISOString()
                },
                orderBy: paginatedSearchQueryParams.sortBy,
            };

            var constructedUrl = `${responseBadgeActivityDetails.deviceServiceAddress}/devices/paginateddatarequest?file=${responseBadgeActivityDetails.dll}&type=${responseBadgeActivityDetails.dllDeviceType}`;
            var result = await this.axiosJson.post(constructedUrl, badgeActivityRequest);

            return result?.data as BadgeActivityPaginatedResponse;
        }
        catch (error) {
            console.error("Error fetching badge activity:", error);
            return {
                pageNumber: 1,
                pageCount: 0,
                totalRecords: 0,
                pageRecords: [],
            } as BadgeActivityPaginatedResponse;
        }
    }
}

const eventsApi = new BadgeActivityApi();
export default eventsApi;
